export const APRS_WEBAPP_SOVI_AI_ENABLED = true;

export const STAGING_TRANSLATION_OPERATORS = [
    { value: "eq", label: "=", hasFindValue: true, findValueShape: "string" },
    { value: "neq", label: "!=", hasFindValue: true, findValueShape: "string" },
    { value: "contains", label: "contains", labelKey: "Translation operator contains", hasFindValue: true, findValueShape: "string" },
    { value: "starts_with", label: "starts with", labelKey: "Translation operator starts with", hasFindValue: true, findValueShape: "string" },
    { value: "ends_with", label: "ends with", labelKey: "Translation operator ends with", hasFindValue: true, findValueShape: "string" },
    { value: "is_null", label: "is null", labelKey: "Translation operator is null", hasFindValue: false, findValueShape: "none" },
    { value: "is_not_null", label: "is not null", labelKey: "Translation operator is not null", hasFindValue: false, findValueShape: "none" },
    { value: "in", label: "in", labelKey: "Translation operator in", hasFindValue: true, findValueShape: "array" },
];

export const operatorMeta = (operator) =>
    STAGING_TRANSLATION_OPERATORS.find((op) => op.value === operator) || null;

export const formatConditionSummary = (translation, translate = null) => {
    if (!translation) return "";
    const meta = operatorMeta(translation.operator);
    const col = translation.column_name;
    if (!meta) return `${col} ${translation.operator} ${translation.find_value ?? ""}`;
    const operatorLabel =
        translate && meta.labelKey ? translate(meta.labelKey) : meta.label;
    switch (translation.operator) {
        case "is_null":
            return `${col} ${operatorLabel}`;
        case "is_not_null":
            return `${col} ${operatorLabel}`;
        case "in": {
            let values = [];
            try { values = JSON.parse(translation.find_value || "[]"); } catch { values = []; }
            const preview = values.slice(0, 3).map((v) => `"${v}"`).join(", ");
            const extra =
                values.length > 3
                    ? `, +${values.length - 3} ${translate ? translate("More values") : "more"}`
                    : "";
            return `${col} ${operatorLabel} (${preview}${extra})`;
        }
        default:
            return `${col} ${operatorLabel} "${translation.find_value ?? ""}"`;
    }
};
